<template>
  <v-dialog v-model="open" max-width="720" persistent>
    <v-card>
      <v-sheet color="grey lighten-2" elevation="1">
        <v-card-title class="d-flex justify-space-between">
          <div >
            <span class="headline">Fale Conosco</span>
          </div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                color="red"
                class="white--text"
                elevation="1"
                small
                @click="closeContactUsForm()"
              >
                <v-icon dark>close</v-icon>
              </v-btn>
            </template>
            <span>Fechar</span>
          </v-tooltip>
        </v-card-title>
      </v-sheet>

      <v-container>
        <v-card class="px-2" replace outlined elevation="2">
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <v-text-field 
                  class="pt-4"
                  v-model="name" 
                  dense 
                  outlined 
                  label="Seu Nome*" 
                  :rules="[rules.required]">
                </v-text-field>
                <v-text-field 
                  class="pt-4"
                  v-model="telephone" 
                  dense 
                  outlined 
                  label="Seu Telefone*" 
                  :rules="[rules.required]">
                </v-text-field>
                <v-text-field 
                  class="pt-4"
                  v-model="email" 
                  dense 
                  outlined 
                  label="Seu Email*" 
                  :rules="[rules.required]">
                </v-text-field>
                <v-textarea 
                  v-model="message"
                  outlined
                  label="Messagem*"
                  :rules="[rules.required]"
                ></v-textarea>
                <div class="pt-0 d-flex justify-center" >
                   <div>
                    <vue-recaptcha
                      ref="recaptcha"
                      @verify="onVerify"
                      @expired="onExpired"
                      :sitekey="sitekey"
                      :loadRecaptchaScript="true">
                    </vue-recaptcha>
                    <div class="d-flex justify-center pt-2">
                      <v-btn
                        color="orange"
                        class="white--text text-capitalize"
                        elevation="1"
                        :disabled="recaptchaVerify"
                        @click="sendContactEmail()"
                      >
                        <v-icon class="pr-2">send</v-icon>
                        Enviar Mensagem
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
        <v-spacer class="pt-12"></v-spacer>
        <v-card>
          <v-card-title>
            Informações de contato
          </v-card-title>
          <v-card-text>

            <v-layout row wrap justify-start align-start>
              <p>
                <v-icon color="blue">place</v-icon>
                {{ contacStreet }} {{ contacNumber }}, {{ contacDistrict }}, {{ contacCity }}/{{ contacState }} CEP {{ contacZip }}
              </p>
            </v-layout>
            <v-layout row wrap justify-start>
              <v-img src="@/assets/icons/whatsapp.png" max-width="24" min-width="24" max-height="24" min-height="24"></v-img>
              <a target="_blank" rel="noopener noreferrer" :href="callWhatsApp" class="pr-4 pl-1"> {{ contacWhatsapp }} </a>
              <v-row>
                <p class="pl-4">
                  <v-icon color="grey">call</v-icon>
                  {{ contactPhone }}
                </p>
              </v-row>
            </v-layout>
            <v-layout class="pt-3" row wrap justify-start>
              <p>
                <v-icon color="grey">mail</v-icon>
                <a :href="sendEmail"> {{ contacEmail }}</a>
              </p>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex';
import apiState from '@/ilios.store';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'ContactUsForm',

  props:{
    open:{
      type: Boolean,
      required: false,
      default: false,
    },

    fillNote:{
      type: String,
      required: false,
      default: '',
    },
  },

  components: {
    VueRecaptcha
  },

  data: () => ({
    sitekey: '',
    recaptchaVerify: true,
    name: null,
    email: null,
    telephone: null,
    message: null,
    recaptchaToken: '',
    rules: {
      required: value => !!value || 'Campo Obrigatório.',
      maxSize: value => !value || value.size < 100000 || 'O tamanho máximo permitido do icone é de 100kb',
      notNegative: value => value > -1 || 'Valor do campo inválido.',
    },
  }),

  mounted() {
    this.sitekey = process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY
  },

  computed: {
    ...mapState('Company', {
      contactPhone: 'companyPhone',
      contacWhatsapp: 'companyWhatsApp',
      contacEmail: 'companyEmail',
      contacStreet: 'companyStreet',
      contacZip: 'companyZip',
      contacNumber: 'companyNumber',
      contacDistrict: 'companyDistrict',
      contacCity: 'companyCity',
      contacState: 'companyState',
    }),

    callWhatsApp() {
      return 'https://api.whatsapp.com/send?phone=' + this.contacWhatsapp;
    },

    sendEmail() {
      return 'mailto:' + this.contacEmail;
    }

  },

  watch: {
    fillNote: function(){
      this.message = this.fillNote
    }
  },

  methods: {
    ...mapActions({
      sendContactMessage: 'Company/contact_us'
    }),

    ...mapGetters({
      getImmobileDetail: 'Immobile/getImmobileDetail',
    }),

    onVerify: function (response) {
     if (response){
       this.recaptchaVerify = false
       this.recaptchaToken = response
     }
    },

    sendContactEmail() {
      let contactInfo = {};
      if (this.fillNote != '') {
        let leadInfo = {};
        let immobileDetails = this.getImmobileDetail();
        leadInfo['id'] = immobileDetails.id;
        leadInfo['codigo_imovel'] = immobileDetails.codigo_imovel + this.name;
        leadInfo['email'] = this.email;
        leadInfo['value'] = immobileDetails.valor_c_doc;
        leadInfo['phone'] = this.telephone;
        leadInfo['description'] = this.message;
        leadInfo['is_opportunity'] = true;
        this.sendContactMessage({
          data: leadInfo
        });
      } else {
        contactInfo['name'] = this.name;
        contactInfo['telephone'] = this.telephone;
        contactInfo['email'] = this.email;
        contactInfo['message'] = this.message;
        this.sendContactMessage({
          data: contactInfo
        });
      };
    },

    onExpired: function () {
      this.recaptchaVerify = true
    },
    
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
    },

    cleanForm(){
      this.name = null
      this.email = null
      this.telephone = null
      this.message = null
    },

    closeContactUsForm(){
      this.cleanForm()
      this.$emit('closeContactUsForm')
    },

  },
};
</script>